import React from 'react'
import LocalEventCard from './LocalEventCard'

export default class EventArticle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      jobHeadline: this.props.job.headline || "",
      events: this.props.events || {},
      eventErrors: {},
      newEvent: false
    }

    this.saveButton = this.saveButton.bind(this);
    this.newEventButton = this.newEventButton.bind(this);

    this.saveArticle = this.saveArticle.bind(this);
    this.checkAndSave = this.checkAndSave.bind(this);
    this.addEventsInputs = this.addEventsInputs.bind(this);
    this.insertEventCard = this.insertEventCard.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleEventUpdate = this.handleEventUpdate.bind(this);

    this.onHeadlineChange = this.onHeadlineChange.bind(this);
  }

  componentDidMount() {
    if(this.state.events.length == 0) { this.insertEventCard() }

    $('[data-save-on-nav]').on('click', (evt) => {
      N2.showProgressIndicator();
      evt.preventDefault();
      let destination = evt.currentTarget.href;
      this.checkAndSave(destination);
      N2.hideProgressIndicator();
    });
  }

  componentWillUnmount() {
    $('[data-save-on-nav]').off('click');
  }

  onHeadlineChange(event) {
    this.setState({jobHeadline: event.target.value});
  }

  handleEventUpdate(eid, field, value) {
    let i = 0;
    for(i = 0; i < this.state.events.length; i++) {
      if(eid == this.state.events[i].id) {
        this.state.events[i][field] = value;
      }
    }
  }

  insertEventCard() {
    if(this.state.newEvent == false) {
      let newEvent = {id: "", title: "", start_on: "", end_on: "", start_at: "",
        end_at: "", all_day: false, location: "", description: "", more_information: ""};
      this.state.events.push(newEvent);
      this.setState({newEvent: true});
    }
    else {
      toastr.options["positionClass"] = "toast-bottom-center";
      toastr["info"]("Please save the new event before adding another.");
    }
  }

  handleDelete(event) {
    let eid = event.target.dataset.eid;
    if(eid.length > 0) {
      N2.showProgressIndicator();
      let form = new N2Styles.manualForm(`/article_jobs/${this.props.job.id}/local_events/${eid}`);
      form.form.attr('method', 'delete');
      this.submitToServer(form);
      let updated = this.state.events.filter(({id}) => id != eid);

      this.setState({events: updated});
      N2.hideProgressIndicator();
    }
    else {
      this.state.events.pop();
      this.setState({newEvent: false});
    }
  }

  checkAndSave(dest = "") {
    let i = 0;
    let errorsPresent = false;
    let err = {};
    for(i = 0; i < this.state.events.length; i++) {
      let curr = this.state.events[i];
      err[curr.id] = {}
      if(curr.title.length == 0) { err[curr.id].title = true; }
      if(curr.start_on.length == 0) { err[curr.id].start_on = true; }
      if(!curr.all_day && (!curr.start_at || curr.start_at.length == 0)) { err[curr.id].start_at = true; }
      if(!curr.all_day && (!curr.end_at || curr.end_at.length == 0)) { err[curr.id].end_at = true; }
      if(Object.keys(err[curr.id]).length > 0) { errorsPresent = true; }
    }
    if(errorsPresent == true) {
      this.setState({eventErrors: err});
      toastr.options["positionClass"] = "toast-bottom-center";
      toastr["info"]("Some required fields are missing.");
    }
    else {
      this.saveArticle(dest);
    }
  }

  saveArticle(dest = "") {
    N2.showProgressIndicator();
    let form = new N2Styles.manualForm(`/article_jobs/${this.props.job.id}`);
    if(dest.length > 0) { form.addInput('destination', dest); }
    form.addInput('article_job[headline]', this.state.jobHeadline);
    this.addEventsInputs(form);
    form.patch();
  }

  addEventsInputs(form) {
    let i = 0;
    for(i=0; i < this.state.events.length; i++){
      form.addInput(`article_job[local_events_attributes][${i}][id]`, this.state.events[i].id);
      form.addInput(`article_job[local_events_attributes][${i}][title]`, this.state.events[i].title);
      form.addInput(`article_job[local_events_attributes][${i}][start_on]`, this.state.events[i].start_on);
      form.addInput(`article_job[local_events_attributes][${i}][end_on]`, this.state.events[i].end_on);
      form.addInput(`article_job[local_events_attributes][${i}][start_at]`, this.state.events[i].start_at);
      form.addInput(`article_job[local_events_attributes][${i}][end_at]`, this.state.events[i].end_at);
      form.addInput(`article_job[local_events_attributes][${i}][all_day]`, this.state.events[i].all_day);
      form.addInput(`article_job[local_events_attributes][${i}][location]`, this.state.events[i].location);
      form.addInput(`article_job[local_events_attributes][${i}][description]`, this.state.events[i].description);
      form.addInput(`article_job[local_events_attributes][${i}][more_information]`, this.state.events[i].more_information);
    }
  }

  submitToServer(form) {
    form.sync({
      success: this.onDestroy,
      error: (req) => { this.onError(req.responseJSON) },
      context: this
    });
  }

  onDestroy() {
    toastr.options["positionClass"] = "toast-bottom-center";
    toastr["info"]("Deleted successfully.");
  }

  onError(resp) {
    toastr.options["positionClass"] = "toast-bottom-center";
    toastr["info"]("Something went wrong, please try again.");
  }

  render() {
    return (
      <div className="container mb-12">

        {this.saveButton()}

        <div className="container mb-6">
          <div className="row">
            <div className="col">
              <div className="card px-4 pt-5">
                <div className="md-form">
                  <input defaultValue={this.state.jobHeadline} maxLength="255" type="text" onChange={this.onHeadlineChange}></input>
                  <label className={this.props.job.headline ? "active" : ""}>Headline</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.events.map((local_event) => {
          return (
            <LocalEventCard key={local_event.id} local_event={local_event} eventErrors={this.state.eventErrors[local_event.id] || {}}
              onDelete={this.handleDelete} onSave={this.checkAndSave} onEventUpdate={this.handleEventUpdate} />
          )
        })}

        {this.newEventButton()}
      </div>
    )
  }

  saveButton() {
    return (
      <div className="row mb-3">
        <div className="col d-flex justify-content-end align-items-center">
          <button className="btn btn-primary cursor-pointer" onClick={this.checkAndSave}>Save Changes</button>
        </div>
      </div>
    )
  }

  newEventButton() {
    return (
      <div className="row pl-3">
        <button className="btn btn-primary cursor-pointer" onClick={this.insertEventCard}>Add Event</button>
      </div>
    )
  }
}
